import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { colors, fontFamily } from "../../theme/palette";

function ResponsiveAppBar() {
  return (
    <Box
      sx={{
        background: colors.bgSoft,
        borderBottom: `1px solid ${colors.border}`,
        px: { xs: 2, md: 4 },
        py: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box
        component="a"
        href="/"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          textDecoration: "none",
        }}
      >
        <Box
          component="img"
          src="/PD.png"
          alt="PicDict"
          sx={{ width: 30, height: 30, objectFit: "contain" }}
        />
        <Typography
          sx={{
            fontWeight: 800,
            fontSize: "1.15rem",
            letterSpacing: "-0.01em",
            color: colors.textPrimary,
            fontFamily,
          }}
        >
          PicDict
        </Typography>
      </Box>
    </Box>
  );
}

export default ResponsiveAppBar;
